import axios from "axios";
import routes from "../../configs/api";

const contactUsForm = async (data) => {
  return new Promise((resolve, reject) => {
    const URL = routes.CONTACT_US;
    axios
      .post(URL, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default contactUsForm;
